import LoadingSpinner from './LoadingSpinner';

/**
 * Full-page loading fallback for lazy-loaded routes
 */
const PageLoadingFallback = ({ message = 'Loading page...' }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="text-center">
        <LoadingSpinner size="lg" />
        <p className="mt-4 text-lg text-gray-600 dark:text-gray-300">{message}</p>
      </div>
    </div>
  );
};

export default PageLoadingFallback;